// 文档 AI 抽取的 action 类型与 thunk。
import { aiExtractionApi } from '../../util/Api';

export const AI_EXTRACTION_START = 'AI_EXTRACTION_START';
export const AI_EXTRACTION_DONE = 'AI_EXTRACTION_DONE';
export const AI_EXTRACTION_ERROR = 'AI_EXTRACTION_ERROR';
export const AI_EXTRACTION_OPEN_DRAWER = 'AI_EXTRACTION_OPEN_DRAWER';
export const AI_EXTRACTION_CLOSE_DRAWER = 'AI_EXTRACTION_CLOSE_DRAWER';
export const AI_EXTRACTION_RESET = 'AI_EXTRACTION_RESET';

export const openAiDrawer = () => ({ type: AI_EXTRACTION_OPEN_DRAWER });
export const closeAiDrawer = () => ({ type: AI_EXTRACTION_CLOSE_DRAWER });
export const resetAiExtraction = () => ({ type: AI_EXTRACTION_RESET });

/**
 * 起一个文档 AI 抽取任务（非阻塞）。
 * 立即置 processing（浮动按钮出现），后台等待 AI 返回；成功置 done 并自动开抽屉，失败置 error。
 */
export const startAiExtraction = ({ jobId, moduleId, documentIds }) => async (dispatch) => {
  dispatch({ type: AI_EXTRACTION_START, payload: { jobId, moduleId } });
  try {
    const { data } = await aiExtractionApi.analyze(jobId, documentIds);
    if (data && data.result) {
      dispatch({ type: AI_EXTRACTION_DONE, payload: data.data });
    } else {
      dispatch({ type: AI_EXTRACTION_ERROR, payload: (data && data.message) || 'AI analysis failed.' });
    }
  } catch (error) {
    const msg = error?.response?.data?.message || error?.message || 'AI analysis failed.';
    dispatch({ type: AI_EXTRACTION_ERROR, payload: msg });
  }
};
